'use client';
import { RelLink } from '@/src/features/ui/rel-link';
import classNames from 'classnames';
import { usePathname } from 'next/navigation';
import { useEffect, useState } from 'react';

type Props = {
  key: string;
  redirectTitle: string;
  url: string;
};

export const ListItem: React.FC<Props> = (props) => {
  const pathname = usePathname();
  const [isActive, setIsActive] = useState(false);

  useEffect(() => {
    if (pathname === props.url) {
      setIsActive(true);
    }
  }, [pathname, props.url]);

  const linkStyle = `md:font-semibold md:py-4 md:pl-6 md:w-[312px] md:border-b-2 md:border-black100 md:rounded-md text-sm`;
  const activeLinkStyle = `md:bg-purple500 md:text-white
                          border-b-4 border-purple500 text-purple500 font-bold pb-4 order-first`;
  const deactiveLinkStyle = 'text-black700';

  return (
    <li key={props.url} className={classNames(linkStyle, isActive ? activeLinkStyle : deactiveLinkStyle, '')}>
      <RelLink href={props.url}>{props.redirectTitle}</RelLink>
    </li>
  );
};
